/**
 * Owner: Masa Bayu
 * File: batch07-codes.ts
 * Date:Time: 2026-09-20 01:05
 * Description: CERT-GLOBAL Batch 7 codes — regional CERTIFIED / Supported.
 */
export const QX_GL_CERT_GLOBAL_BATCH_07_ID = 'QX-GL-CERT-GLOBAL-BATCH-07';
export const QX_GL_CERT_GLOBAL_BATCH_07_TYPE = 'regional-family-batch';
export const QX_BATCH_07_MODEL_VERSION = '1.1.0';
export const QX_BATCH_07_PHASE = 'CLOSED';
/** OPEN stamp — Batch 7 work authorization (not Supported). */
export const QX_BATCH_07_OPENED_AT = '2026-09-19T16:53:00.000Z';
/** READY stamp — regional evidence packs complete. */
export const QX_BATCH_07_READY_AT = '2026-09-19T16:59:00.000Z';
/** Owner Accept stamp — regional CERTIFIED + Supported. */
export const QX_BATCH_07_OWNER_ACCEPTED_AT = '2026-09-19T17:05:00.000Z';
export const QX_BATCH_07_FAMILY_IDS = [
    'armenian',
    'georgian',
    'ethiopic',
    'tibetan',
];
export const QX_BATCH_07_EVIDENCE_AREAS = [
    'identity',
    'script',
    'direction',
    'content',
    'qxw',
    'qxp',
    'reader',
    'search',
    'navigation',
    'annotation',
    'accessibility',
    'serialization',
    'regression',
    'provenance',
];
export function isQxBatch07FamilyId(value) {
    return (typeof value === 'string' &&
        QX_BATCH_07_FAMILY_IDS.includes(value));
}
//# sourceMappingURL=batch07-codes.js.map